import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
// import PropTypes from 'prop-types';

// Components
import Banner from 'components/Banner/Banner';
import Button from 'components/_shared/Button/Button';
// import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';

// SVGs
import { ReactComponent as LeftChev } from 'svgs/lft_arrow.svg';
import { ReactComponent as RightChev } from 'svgs/rt_arrow.svg';
import { ReactComponent as Collapse } from 'svgs/less_icon.svg';
import { ReactComponent as Expand } from 'svgs/more_icon.svg';

// Constants
import { pathwaysData, pathwaysGlossary } from 'constants/constants';

// Services
import { pathwaysLeaderLines, addArc } from 'services/lineCreators';

// Styles
import './Pathways.css';

// Redux Actions
import { setFilter } from 'store/modules/db/search/searchReducer';

export class Pathways extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //
  state = {
    pathways: null,
    lines: [],
    width: null,
    pathIndex: 0,
    macros: []
  }

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  componentDidMount() {
    this.pathsRef.addEventListener("swipeleft", this.handleSwipeLeft)
    this.pathsRef.addEventListener("swiperight", this.handleSwipeRight)
    // setup leader lines
    // this.mountLines();
    if (navigator.userAgent !== 'ReactSnap') {
      this.cleanMount();
      window.addEventListener("resize", this.updateDimensions);
    }
  }

  componentDidUpdate() {
    // change pathways border radius
    if (this.state.pathways && !this.state.lines.length && navigator.userAgent !== 'ReactSnap') {
      this.setPathways();
    }
  }

  componentWillUnmount() {
    if (navigator.userAgent !== 'ReactSnap') {
      this.clearPathways();
      window.removeEventListener("resize", this.updateDimensions);
    }
    this.pathsRef.removeEventListener("swipeleft", this.handleSwipeLeft)
    this.pathsRef.removeEventListener("swiperight", this.handleSwipeRight)
  }

  // Event handlers
  // ------------------------------------------------------------------------ //
  directoryNav = () => {
    this.props.dispatch(push('/directory'))
  }

  filterAndGo = (e, filter) => {
    if (e) e.preventDefault();
    this.props.dispatch(setFilter({
      type: 'pipeline',
      query: filter.toUpperCase()
    }))
    this.props.dispatch(push('/directory'))
  }

  handleMacro = (e, macro) => {
    let macros = [...this.state.macros]
    if (macros.indexOf(macro) < 0) {
      macros = macros.concat(macro);
    } else {
      macros = macros.filter(mac => mac !== macro)
    }

    this.setState({macros});
  }

  handleSwipeLeft = () => {
    const pathTypes = Object.keys(pathwaysData[Object.keys(pathwaysData)[0]]);
    this.handleScroll(null, pathTypes, 1)
  }

  handleSwipeRight = () => {
    const pathTypes = Object.keys(pathwaysData[Object.keys(pathwaysData)[0]]);
    this.handleScroll(null, pathTypes, 0)
  }

  handleScroll = (e, pathTypes, direction) => {
    let pathIndex;

    if (direction) {
      if (this.state.pathIndex >= pathTypes.length - 1) {
        pathIndex = 0;
      } else {
        pathIndex = this.state.pathIndex + 1;
      }
    } else {
      if (!this.state.pathIndex) {
        pathIndex = pathTypes.length - 1;
      } else {
        pathIndex = this.state.pathIndex - 1;
      }
    }


    this.setState({pathIndex})
  }

  // Class methods
  // ------------------------------------------------------------------------ //
  clearPathways = () => {
    let { pathways } = this.state;
    if (pathways) {
      Object.keys(pathways).forEach(line => {
        pathways[line].remove();
      })
    }
  }

  mountLines = () => {
    let refs = {
      heroRef: this.heroRef,
      pathsRef: this.pathsRef,
      directoryBtnRef: this.directoryBtnRef,
    }

    this.setState({
      pathways: pathwaysLeaderLines(window.innerWidth, refs)
    });
  }

  cleanMount = () => {
    this.clearPathways();
    this.setState({
      width: window.innerWidth,
      pathways: null
    }, () => {
      this.mountLines()
    })
  }

  updateDimensions = () => {
    this.cleanMount();
    this.setPathways();
    // this.forceUpdate()
  }

  setPathways = () => {
    let lines = Array.from(document.getElementsByClassName(`leader-line-line-path`))
      .map(line => {
        try {
          line.setAttribute('d', addArc(line.getAttribute('d'), 50));
        } catch (e) {
        }
        return line;
      }
      ).filter(path => path)

    this.setState({lines})
  }

  assignRefFunc = refEle => {
    const self = this;
    return ref => {
      self[refEle] = ref;
    }
  }

  // Render methods
  // ------------------------------------------------------------------------ //
  renderPathTypes = (pathTypes, width) => {
    let paths;

    if (width && width > 1150) {
      paths = pathTypes.map(path => (
        <li key={path} className={`pathways__type`}>
          <strong>{path}</strong>
        </li>
      ))
    } else {

      paths = pathTypes
        .filter(
          (path, idx) => idx === this.state.pathIndex
        )
        .map(path => (
          <li key={path} className={`pathways__type`}>
            <strong>{path}</strong>
          </li>
        ))
    }

    return paths;
  }


  renderMicros = (pathwaysData, macro, width, index) => {
    let micros;
    let microFilter = this.filterAndGo;

    micros = Object.keys(pathwaysData[macro])
      .filter((subMacro, idx) => {
        if (width && width > 1150) {
          return true;
        } else {
          return idx === this.state.pathIndex;
        }
      })
      .map(subMacro => {
      return (
        <li key={subMacro} className={`pathways__subMacro`}>
        <ul className={`pathways__table_col`}>
          {pathwaysData[macro][subMacro]
            .map(micro => {
              let output;
              switch(macro) {
                case 'Goals':
                  output = (
                  <li
                    key={micro}
                    className={`pathways__micro`}
                    onClick={index === 1 ?
                      e => microFilter(e, micro)
                      :
                      null
                    }><p dangerouslySetInnerHTML={{ __html: micro }}></p></li>);
                  break;
                case 'Services & Delivery':
                  output = (
                    <li key={micro}
                  className={`pathways__micro`}>
                  <a href="#/" 
                  onClick={index === 1 ?
                    e => microFilter(e, micro)
                    :
                    null
                  }>
                {micro === 'Student Supports' ? 'Student Support' : micro}</a>
              </li>);
                  break;
                default:
                  output = (
                  <li
                    key={micro}
                    className={`pathways__micro`}
                    onClick={index === 1 ?
                      e => microFilter(e, micro)
                      :
                      null
                    }><p>{micro}</p>
                    </li>);
                  break;
              }
              return output;
          })}
        </ul>
      </li>
      )
    })

    return micros;
  }

  render() {
    const pathTypes = Object.keys(pathwaysData[Object.keys(pathwaysData)[0]]);
    const { width } = this.state;
    const serviceHelpText = '(Services link to relevant organizations)';

    return (
      <div className="pathways">
        {/* Hero */}
        <section
          className={`pathways__hero`}>
          <div className={`pathways__hero-depict`}>
            <h1>Creative Career Pathways</h1>
            <p>artworxLA has interviewed and identified the organizations that make up <strong>Elevate</strong>’s Creative Career Pathway. Building our knowledge amplifies our collective impact in connecting LA's Opportunity Youth with existing resources. This means understanding what each sector brings to the pathway and how they support our students.</p>
            <Button
              refFunc={this.assignRefFunc('directoryBtnRef')}
              className="pathways__button"
              onClick={this.directoryNav}
              value="Find a specific org"
            />
            <div
              ref={ref => this[`heroRef`] = ref}
              className={`pathways__hero-dumb`}/>
          </div>
          <article className={`pathways__hero-info`}>
            <p>We, at artworxLA, have interviewed and identified the organizations that make up <strong>Elevate</strong>’s ecosystem, or pathway. Building our knowledge amplifies our collective impact in connecting with LA’s opportunity youth. This means understanding what each sector brings to the pathway and how they support our students.</p>
          </article>
        </section>

        <section 
          ref={ref => this[`pathsRef`] = ref}
          className={`pathways__paths`}>
            <p><em>Swipe through the 6 sectors to learn more about each</em></p>
          <div className={`pathways__paths-container`}>
            <ul className={`pathways__paths-headers`}>
              {this.renderPathTypes(pathTypes,width)}
            </ul>
            <div
              className={`pathways__paths-scrolls`}
              >
                <LeftChev 
                  onClick={e => this.handleScroll(e, pathTypes, 0)}
                  className={`pathways__left-chev`}/>
                <RightChev 
                  onClick={e => this.handleScroll(e, pathTypes, 1)}
                  className={`pathways__right-chev`}/>
            </div>
          </div>
          <ul className={`pathways__list`}>
            {Object.keys(pathwaysData).map((macro, idx) => {
              let hasMacro = this.state.macros.indexOf(macro) < 0;
              return (
                <li key={macro} className={`
                  pathways__macro
                  ${!hasMacro ? 'pathways--hasMacro' : ''}
                  `}>
                  <div className={`pathways__macro-title`}>
                    <div>
                      <p>{macro}</p>
                      <em>{macro === 'Services & Delivery' ? serviceHelpText : null}</em>
                    </div>
                    <div
                      className={`pathways__macro-toggles`}
                      onClick={e => this.handleMacro(e, macro)}>
                      { hasMacro ? <Expand /> : <Collapse />}
                    </div>
                  </div>
                  <ul className={`pathways__table-row`}>
                    {this.renderMicros(pathwaysData, macro, width, idx)}
                  </ul>
                </li>
              )})}
          </ul>
        </section>

        {/* Glossary */}
        <section className={`pathways__glossary`}>
          <h2>Glossary of 'Services & Delivery' Terms</h2>
          <ul className={`pathways__glossary-list`}>
          {Object.keys(pathwaysGlossary).map(gloss => {

            let glossFilter = this.filterAndGo;
            return (
              <li key={gloss} 
              onClick={e => glossFilter(gloss)}
              className={`pathways__gloss`}>
                <h3>{gloss}</h3>
                <p>{pathwaysGlossary[gloss]}</p>
              </li>
            )
          })}
          </ul>
        </section>
        <Banner />
      </div>
    );
  }
}

export default connect(null)(Pathways)



// WEBPACK FOOTER //
// ./src/components/Pathways/Pathways.js